import { combineReducers } from 'redux';
import _omit from 'lodash/omit';

import {
  ACTION_SET_SITE_FOOTER_LINKS_PAGES,

  ACTION_DELETE_PAGE__REQUEST,
  ACTION_DELETE_PAGE__SUCCESS,
  ACTION_DELETE_PAGE__FAIL,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_SET_SITE_FOOTER_LINKS_PAGES:
      return action.payload.siteFooterLinksPages;

    default:
      return state;
  }
};

const isBeingDeleted = (state = {}, action) => {
  switch (action.type) {
    case ACTION_DELETE_PAGE__REQUEST:
      return { ...state, [action.payload.pageId]: true };

    case ACTION_DELETE_PAGE__SUCCESS:
    case ACTION_DELETE_PAGE__FAIL:
      return _omit(state, action.payload.pageId);

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  isBeingDeleted,
});
